import { useMemo } from 'react';
import objectPath from 'object-path';
import { useHtmlClassService } from '..';

export function Footer() {
    const today = new Date().getFullYear();
    const uiService = useHtmlClassService();

    const layoutProps = useMemo(() => {
        return {
            footerLayout: objectPath.get(uiService.config, 'footer.layout'),
            footerClasses: uiService.getClasses('footer', true),
            footerContainerClasses: uiService.getClasses('footer_container', true),
        };
    }, [uiService]);

    return (
        <footer className={`footer py-4 d-flex flex-lg-column ${layoutProps.footerClasses}`} id="kt_footer">
            <div
                className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
            >
                <div className="text-dark order-2 order-md-1 ml-md-4">
                    <span className="text-muted font-weight-bold mr-">{today} &copy;</span>
                    {` `}
                    <a
                        href="https://www.influencevision.com/"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="text-dark-75 text-hover-primary"
                    >
                        influence.vision
                    </a>
                </div>

                {/* <div className="nav nav-dark order-1 order-md-2 fw-bold">
                    <a href="/" target="_blank" rel="noopener noreferrer" className="nav-link pr-3 pl-0">
                        About
                    </a>
                </div> */}
            </div>
        </footer>
    );
}
